import type { Locale } from "../content/types";
import { landingByLocale } from "../content";
import { PageMeta } from "../components/PageMeta";
import { Header } from "../components/Header";
import { Footer } from "../components/Footer";
import { HeroSection } from "../sections/HeroSection";
import { FeatureGrid } from "../sections/FeatureGrid";
import { GallerySection } from "../sections/GallerySection";
import { PrivacySection } from "../sections/PrivacySection";

type LandingPageProps = {
  locale: Locale;
};

export function LandingPage({ locale }: LandingPageProps) {
  const content = landingByLocale[locale];

  return (
    <>
      <PageMeta title={content.seo.title} description={content.seo.description} locale={locale} kind="landing" />
      <Header locale={locale} kind="landing" nav={content.nav} variant="full" />
      <main>
        <HeroSection content={content.hero} secondaryHref="#features" locale={locale} />
        <GallerySection content={content.gallery} />
        <FeatureGrid content={content.features} />
        <PrivacySection content={content.privacy} locale={locale} />
      </main>
      <Footer locale={locale} kind="landing" content={content.footer} />
    </>
  );
}
